export default __webpack_public_path__ + "b8c3febf285d217cbe3de2a6fd96b70b.png";